import {makeStyles} from "@material-ui/styles";
import red from "@material-ui/core/colors/red";

    export const themeButtons = makeStyles({
    btnGreen: {
        backgroundColor: "#00b74a",
        fontWeight: 400,
        padding: ".5rem 1.5rem",
        lineHeight: 1.5,
        color: '#fff',
        textAlign: "center",
        webkitBoxShadow: "0 2px 5px 0 rgb(0 0 0 / 20%), 0 2px 10px 0 rgb(0 0 0 / 10%)",
        boxShadow: "0 2px 5px 0 rgb(0 0 0 / 20%), 0 2px 10px 0 rgb(0 0 0 / 10%)",
        '&:hover': {
            backgroundColor: "#00913b",
	        color: '#fff',
            textDecoration: 'none'
        },
        '&:disabled': {
            color: '#fff!important',
            opacity: '.65',
        }
    },
    btnGreenOutline: {
        color: "#00b74a",
        fontWeight: 400,
        padding: ".5rem 1.5rem",
        lineHeight: 1.5,
        textAlign: "center",
        borderColor: "#00b74a",
    },
    btnBlackOutline: {
        color: "#222",
        borderColor: "#222",
        textAlign: "center",
        '&:hover': {
            backgroundColor: "#fafafa",
        },
    },
    btnWarn: {
        color: "#222!important",
        textDecoration: "none!important",
        fontWeight: 400,
        padding: ".5rem 1.5rem",
        lineHeight: 1.5,
        textAlign: "center",
        webkitBoxShadow: "0 2px 5px 0 rgb(0 0 0 / 20%), 0 2px 10px 0 rgb(0 0 0 / 10%)",
        boxShadow: "0 2px 5px 0 rgb(0 0 0 / 20%), 0 2px 10px 0 rgb(0 0 0 / 10%)",
        backgroundColor: "#ffa900",
        '&:hover': {
            backgroundColor: "#d99000",
        },
        '&:disabled': {
            color: '#222',
            opacity: '.65',
        }
    },
    btnWarnOutline: {
        color: "#ffa900",
        fontWeight: 400,
        padding: ".5rem 1.5rem",
        lineHeight: 1.5,
        textAlign: "center",
        borderColor: "#ffa900",
    },

    btnDanger: {
        backgroundColor: red[500],
        fontWeight: 400,
        padding: ".5rem 1.5rem",
        lineHeight: 1.5,
        color: '#fff',
        textAlign: "center",
        webkitBoxShadow: "0 2px 5px 0 rgb(0 0 0 / 20%), 0 2px 10px 0 rgb(0 0 0 / 10%)",
        boxShadow: "0 2px 5px 0 rgb(0 0 0 / 20%), 0 2px 10px 0 rgb(0 0 0 / 10%)",
        '&:hover': {
            backgroundColor: red[700],
        },
        '&:disabled': {
            color: '#fff',
            opacity: '.65',
        }
    },
    btnLight: {
        backgroundColor: '#fff',
        color: '#222',
        fontWeight: 400,
        padding: ".5rem 1.5rem",
        lineHeight: 1.5,
        textAlign: "center",
        webkitBoxShadow: "0 2px 5px 0 rgb(0 0 0 / 20%), 0 2px 10px 0 rgb(0 0 0 / 10%)",
        boxShadow: "0 2px 5px 0 rgb(0 0 0 / 20%), 0 2px 10px 0 rgb(0 0 0 / 10%)",
        '&:hover': {
            color: "#4f4f4f",
            backgroundColor:" #e8e8e8"
        },
        '&:disabled': {
            color: '#fff',
            opacity: '.65',
        }
    }
})
